export default "__VITE_ASSET__5qHzkA4d__"